import type { z } from "zod";
import type {
  agentProcessStepSchema,
  baseBlockSchema,
  baseContainerSchema,
  blockAgentProcessSchema,
  blockButtonsSchema,
  blockContextActionSchema,
  blockContextConditionSchema,
  blockDotsSchema,
  blockFormSuccessSchema,
  blockLiveChatSchema,
  blockMediaSchema,
  blockStepsSchema,
  blockTextSchema,
  chatContainersSchema,
  chatCustomBlockSchema,
  chatCustomContainersSchema,
  chatFastActionSchema,
  chatMessageSchema,
  chatOpenCustomBlockSchema,
  containerActionsRowSchema,
  containerCardSchema,
  containerCarouselSchema,
  containerSectionSchema,
  liveChatContextSchema,
  metadataSchema,
  usedSourceMetadatasSchema,
} from "../schemas/chat";

export type BaseBlock = z.infer<typeof baseBlockSchema>;
export type BlockContextAction = z.infer<typeof blockContextActionSchema>;
export type BlockContextCondition = z.infer<typeof blockContextConditionSchema>;

export enum ChatCustomBlockTypes {
  /** Internal tooling only: agent run trace, never produced by the chatbot pipeline. */
  agentProcess = "agentProcess",
  bouncingDots = "bouncingDots",
  buttons = "buttons",
  event = "events",
  formSuccess = "formSuccess",
  liveChat = "liveChat",
  media = "media",
  steps = "steps",
  text = "text",
  separator = "separator",
}

export enum DoChatAction {
  close = "dialonce-close",
  editBotResponse = "editBotResponse",
  newSourcesToAdd = "newSourcesToAdd",
  resetUsedSources = "resetUsedSources",
}

export enum QualificationSubtypeTypes {
  advanced = "advanced",
  generative = "generative",
  response = "response",
}

export enum ChatContainerTypes {
  actionsRow = "actions_row",
  card = "card",
  carousel = "carousel",
  grid = "grid",
  section = "section",
}

export enum TextFormResponseBlockRole {
  Description = "description",
  Title = "title",
}

export enum MediaBlockMediaTypes {
  Image = "image",
  Video = "video",
  Youtube = "youtube",
  Icon = "icon",
}

export type QualificationSubtypes = keyof typeof QualificationSubtypeTypes;

export type BlockSteps = z.infer<typeof blockStepsSchema>;

export type BlockButtons = z.infer<typeof blockButtonsSchema>;

export type BlockText = z.infer<typeof blockTextSchema>;

export type BlockDots = z.infer<typeof blockDotsSchema>;

export type BlockLiveChat = z.infer<typeof blockLiveChatSchema>;

export type BlockMedia = z.infer<typeof blockMediaSchema>;

export type BlockFormSuccess = z.infer<typeof blockFormSuccessSchema>;

export type BlockAgentProcess = z.infer<typeof blockAgentProcessSchema>;

export type AgentProcessStep = z.infer<typeof agentProcessStepSchema>;

export type ChatCustomBlock = z.infer<typeof chatCustomBlockSchema>;

export type ChatOpenCustomBlock = z.infer<typeof chatOpenCustomBlockSchema>;

export type ChatFastAction = z.infer<typeof chatFastActionSchema>;

export type ChatMessage = z.infer<typeof chatMessageSchema>;

export type UsedSourceMetadatas = z.infer<typeof usedSourceMetadatasSchema>;

export type LiveChatContext = z.infer<typeof liveChatContextSchema>;

export type Metadata = z.infer<typeof metadataSchema>;

export type BaseContainer = z.infer<typeof baseContainerSchema>;

export type ContainerActionsRow = z.infer<typeof containerActionsRowSchema>;

export type ContainerCard = z.infer<typeof containerCardSchema>;

export type ContainerCarousel = z.infer<typeof containerCarouselSchema>;

export type ContainerSection = z.infer<typeof containerSectionSchema>;

export type ChatContainers = z.infer<typeof chatContainersSchema>;

export type ChatCustomContainers = z.infer<typeof chatCustomContainersSchema>;
